import { Icon } from 'common/Icon'
import { formatAddress } from 'common/Web3/formatAddress'
import { useStore } from 'lib/store'
import { styled, ComponentProps } from 'lib/theme'
import { observer } from 'mobx-react-lite'
import { Button } from 'primitives/Button'
import { Text } from 'primitives/Text'

const WalletIndicatorButton = styled(Button, {
  borderRadius: 8,
  padding: '7px 16px',
  color: '$gray800',
  '&:disabled': {
    cursor: 'default'
  }
})

interface Props extends ComponentProps<typeof WalletIndicatorButton> {}
const _ConnectedWallet: React.FC<Props> = ({ css }) => {
  const { injectedWallet, ui } = useStore()

  const handleClick = () => {
    if (injectedWallet.isLinked) {
      ui.openConnectModal('DISCONNECT')
    } else {
      ui.openConnectModal('LINK_WALLET')
    }
  }

  return (
    <WalletIndicatorButton
      css={{
        borderRadius: 0,

        textTransform: 'none',
        padding: '8px 17px',
        justifyContent: 'start',
        gap: '7px',
        '& .primary.fill': {
          fill: injectedWallet.isLinked ? '$voilet200' : '$red100 '
        },
        '&:hover': {
          p: { color: '$gray900' },
          '& .primary.fill': {
            fill: injectedWallet.isLinked ? '$gray900' : '$red100 '
          }
        },
        ...css
      }}
      onClick={handleClick}
    >
      <Icon
        icon="Wallet"
        css={{
          width: 14,
          height: 14,
          '& .primary.fill': { fill: '$gray800' }
        }}
      />
      <Text
        type="body2"
        subText
        css={{
          color: injectedWallet.isLinked ? '$voilet200' : ' $red100 !important '
        }}
      >
        {' '}
        {injectedWallet.connectedAddress
          ? formatAddress(injectedWallet.connectedAddress)
          : 'Connect wallet'}{' '}
      </Text>
    </WalletIndicatorButton>
  )
}

export const ConnectedWallet = observer(_ConnectedWallet)
